import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useWbpModel } from "../wbpModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { IWbpDetail } from "../wbpTypes";
import { formatNum } from "@/utils/utils";
import moment from 'moment';


export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, loading,
        loadData, setSelectedRowKeys
    } = useWbpModel();

    const { getTreeNodeName, getTreeNodeValue } = useDictModel(() => []);

    useEffect(() => {
        loadData()
    }, [])

    const columns: ColumnsType<IWbpDetail> = [
        {
            title: '序号',
            width: 45,
            fixed: "left",
            dataIndex: "totalTxt",
            render: (t: any, r: any, i: number) => <>{t ? t : i + 1}</>
        }, {
            title: '证书编号',
            width: 160,
            dataIndex: 'code',
            fixed: "left",
        }, {
            title: '状态',
            width: 100,
            dataIndex: 'status',
            render: t => t === 0 ? "已登记" : "已作废"
        }, {
            title: '预警状态',
            width: 100,
            dataIndex: 'warningType',
            render: text => getTreeNodeName(text)
        }, {
            title: '文件类型',
            width: 160,
            dataIndex: 'agreementType',
            render: text => getTreeNodeName(text),
            ellipsis: true,
        }, {
            title: '签发日期',
            width: 160,
            dataIndex: 'signingTime',
            render:t => moment(t).format("YYYY-MM-DD HH:mm:ss"),
            ellipsis: true,
        }, {
            title: '生效日期',
            width: 160,
            dataIndex: 'customerName',
            render:t => moment(t).format("YYYY-MM-DD HH:mm:ss"),
            ellipsis: true,
        }, {
            title: '到期日期',
            width: 160,
            dataIndex: 'createTime',
            render:t => moment(t).format("YYYY-MM-DD HH:mm:ss"),
            ellipsis: true,
        }, {
            title: '创建人',
            width: 80,
            dataIndex: "createUser"
        }, {
            title: '创建时间',
            width: 200,
            dataIndex: "createTime",
            render:t => moment(t).format("YYYY-MM-DD HH:mm:ss"),
        }, {
            title: '更新时间',
            width: 180,
            dataIndex: 'updateTime',
            render:t => moment(t).format("YYYY-MM-DD HH:mm:ss"),
        }, {
            title: '备注',
            width: 100,
            dataIndex: 'note',
            ellipsis: true,
        }
    ];


    //点击行选高亮
    const onRow = (code: string) => {
        let findIndex = selectedRowKeys.indexOf(code);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(code);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };


    return (
        <Table
            rowKey={record => record.id}
            loading={loading}
            rowSelection={{
                //全部选中时  (存string[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    let changeRowId = changeRows.map(item => item.id).filter(item => item !== "listTotalAmount");
                    selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
                        : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
                },
                onSelect: (record) => onRow(record.id),
                selectedRowKeys: selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.id]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 360px)" }}
        />
    )
}
